<div class="commodity-reports">
  <div class="reports-page" *ngIf="manifest; else stateTpl">
    <div class="page-header">
      <div>
        <h1>Commodity Reports</h1>
        <p class="subtitle">
          Daily market reports from the Yukka Reporting Service — one overview
          report, three desk aggregates, and per-commodity deep dives. Reports
          open in a new tab.
        </p>
      </div>
      <div class="header-actions">
        <a
          class="methodology-link"
          [href]="methodologyUrl()"
          target="_blank"
          rel="noopener noreferrer"
        >
          <mat-icon>school</mat-icon>Methodology
        </a>
        <span class="date-label">
          <mat-icon>calendar_today</mat-icon
          >{{ manifest.date | date: 'd MMMM y' }}
        </span>
      </div>
    </div>

    <div class="filter-row">
      <div class="filter-search">
        <mat-icon>search</mat-icon>
        <input
          type="text"
          name="commodityFilter"
          [(ngModel)]="filter"
          placeholder="Filter commodities… e.g. copper, LNG, cocoa"
        />
      </div>
      <button type="button" class="expand-btn" (click)="toggleAll()">
        <mat-icon>unfold_more</mat-icon>
        {{ allOpen ? 'Collapse all' : 'Expand all' }}
      </button>
    </div>

    <a
      class="main-report"
      [href]="overviewUrl()"
      target="_blank"
      rel="noopener noreferrer"
    >
      <span class="mr-icon"><mat-icon>insights</mat-icon></span>
      <span class="mr-text">
        <span class="mr-title">{{ manifest.title }}</span>
        <span class="mr-sub"
          >Cross-desk daily summary covering all energy, metals and soft
          commodities — {{ manifest.date | date: 'd MMMM y' }}</span
        >
      </span>
      <span class="mr-open">Open report<mat-icon>open_in_new</mat-icon></span>
    </a>

    <div class="section-label">Desks</div>

    <div
      class="desk"
      *ngFor="let desk of manifest.deskReports"
      [class.open]="deskExpanded(desk)"
      [hidden]="!deskVisible(desk)"
    >
      <div class="desk-header" (click)="toggleDesk(desk)">
        <span class="desk-caret"><mat-icon>chevron_right</mat-icon></span>
        <span class="desk-icon"
          ><mat-icon>{{ deskIcon(desk) }}</mat-icon></span
        >
        <span class="desk-title">
          <span class="desk-name">{{ desk.title }}</span>
          <span class="desk-sub" *ngIf="deskSubtitle(desk)">{{
            deskSubtitle(desk)
          }}</span>
        </span>
        <span class="desk-count"
          >{{ desk.commodityReports.length }} commodities</span
        >
        <a
          class="desk-report-btn"
          [href]="deskReportUrl(desk)"
          target="_blank"
          rel="noopener noreferrer"
          (click)="$event.stopPropagation()"
        >
          <mat-icon>description</mat-icon>Desk report<mat-icon
            >open_in_new</mat-icon
          >
        </a>
      </div>
      <div class="desk-body">
        <div class="commodity-grid">
          <a
            class="commodity-item"
            *ngFor="let report of visibleCommodities(desk)"
            [href]="commodityUrl(report)"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span class="dot"></span>
            <span class="name">{{ report.title }}</span>
            <mat-icon>open_in_new</mat-icon>
          </a>
        </div>
      </div>
    </div>

    <div class="no-results" *ngIf="!anyVisible">
      No commodities match your filter.
    </div>

    <div class="page-footnote">
      <mat-icon>info_outline</mat-icon>{{ totalCommodities }} commodity reports
      across {{ manifest.deskReports.length }} desks · maintained by YUKKA Lab ·
      updated daily
    </div>
  </div>

  <ng-template #stateTpl>
    <div class="reports-page">
      <div class="cr-state" *ngIf="loading">
        <mat-spinner [diameter]="34"></mat-spinner>
      </div>
      <div class="cr-state" *ngIf="error">
        <mat-icon>error_outline</mat-icon>
        <p>Couldn’t load the commodity reports.</p>
        <button type="button" class="expand-btn" (click)="load()">
          <mat-icon>refresh</mat-icon>Try again
        </button>
      </div>
    </div>
  </ng-template>
</div>
